import React from 'react'
import './My Performance Huddle.css'
import PmPerformancePoints from '../PM TEMPLATE/PM PERFORMANCE POINT/PmPerformancePoints'
import PmOverallJobPerformance from '../PM TEMPLATE/PM OVERALL JOB PERFORMANCE/PmOverallJobPerformance'
import { TabPanel, TabView } from 'primereact/tabview'


function MyPerformanceHuddle() {
    return (
        <>

            <div className="card p-0" >
                <TabView multiple >
                    <TabPanel header="PERFORMANCE HUDDLE" className="accordian-header m-2">
                        <PmPerformancePoints />
                    </TabPanel>
                    <TabPanel header="OVERALL JOB PERFORMANCE" className="accordian-header m-2">
                        <PmOverallJobPerformance />
                    </TabPanel>
                </TabView>
            </div>
        </>
    )
}

export default MyPerformanceHuddle